import { render, staticRenderFns } from "./RavakLogo.vue?vue&type=template&id=8b441fd2&scoped=true&"
var script = {}
import style0 from "./RavakLogo.vue?vue&type=style&index=0&id=8b441fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b441fd2",
  null
  
)

export default component.exports